import {match} from 'ts-pattern';

import type {FinancialProductType} from '../schemas/FinancialProductTypeSchema';

/** Structural product slots retain the caller's offer subtype rather than a shared DTO type. */
export const getFinancialProductOffer = <
  Products extends {
    readonly standard: object | null;
    readonly balloon: object | null;
    readonly leasing: object | null;
  },
>(
  products: Products,
  productType: FinancialProductType
): Products['standard'] | Products['balloon'] | Products['leasing'] =>
  match(productType)
    .with('STANDARD', (): Products['standard'] => products.standard)
    .with('BALLOON', (): Products['balloon'] => products.balloon)
    .with('LEASING', (): Products['leasing'] => products.leasing)
    .exhaustive();
